import { render } from "./EmptySpace.vue?vue&type=template&id=efd69c2a&scoped=true"
import script from "./EmptySpace.vue?vue&type=script&lang=js"
export * from "./EmptySpace.vue?vue&type=script&lang=js"

import "./EmptySpace.vue?vue&type=style&index=0&id=efd69c2a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd69c2a"]])

export default __exports__